import React from "react";
import withReloading from "common/withReloading";
import SettingsView from ".";

const ReloadingSettings = withReloading(SettingsView);

const ReloadingSettingsView = ({ load, ...settings }) => (
  <ReloadingSettings provider={load} {...settings} />
);

export default ReloadingSettingsView;
